import { useState, useRef } from 'react';
import Breadcrumb from '@/components/base/Breadcrumb';
import SchemaOrg from '@/components/base/SchemaOrg';
import { brandInfo } from '@/mocks/brand';

export default function About() {
  const { stats, milestones, team, testimonials } = brandInfo;

  const faqs = [
    { question: '老色哥是什么平台？', answer: '老色哥是国内领先的成熟男性穿搭风格与生活美学平台，汇聚资深穿搭达人和生活家，专注为30-55岁的成熟男性提供专业的穿搭指导、生活美学内容和社区交流。' },
    { question: '老色哥的内容涵盖哪些方面？', answer: '我们的内容涵盖经典绅士穿搭、复古搭配、休闲日常、配饰推荐、生活美学和护肤健康六大领域，全方位打造成熟男人的品味生活。' },
    { question: '如何加入老色哥社区？', answer: '您可以通过订阅我们的邮件通讯加入老色哥社区，第一时间获取最新穿搭指南和活动资讯。我们也会不定期举办线下穿搭沙龙活动，欢迎关注。' },
    { question: '老色哥的内容是免费的吗？', answer: '是的，老色哥所有线上文章、穿搭指南和生活美学内容均免费向所有用户开放。我们坚持分享优质内容，帮助每一位成熟男性找到属于自己的风格。' },
    { question: '如何联系老色哥团队？', answer: '您可以通过以下方式联系我们：邮箱 contact@laosege.com，电话 021-6288-8888，或关注我们的微信公众号"老色哥官方公众号"。对于商务合作和品牌推广，请发送邮件至合作邮箱，我们会在2个工作日内回复。' },
  ];

  const [contactStatus, setContactStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [contactError, setContactError] = useState('');
  const contactFormRef = useRef<HTMLFormElement>(null);

  const handleContactSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('phone_alt');
    if (honeypot && String(honeypot).trim() !== '') {
      setContactStatus('success');
      form.reset();
      return;
    }

    formData.delete('phone_alt');

    try {
      const response = await fetch('https://readdy.ai/api/form/d9rgpk7nahb7382ovma0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        setContactStatus('success');
        form.reset();
      } else {
        const msg = parsed?.meta?.message || parsed?.message || '提交失败，请稍后再试';
        setContactError(msg.includes('spam') ? '提交失败，请稍后再试' : msg);
        setContactStatus('error');
      }
    } catch {
      setContactError('网络错误，请检查连接后重试');
      setContactStatus('error');
    }
  };

  return (
    <>
      <SchemaOrg type="Organization" />
      <SchemaOrg type="WebPage" data={{
        name: '关于我们 - 老色哥穿搭风格指南',
        description: '了解老色哥的品牌故事、团队介绍、用户口碑及联系方式。老色哥是专为成熟男性打造的穿搭风格与生活美学平台。',
        url: 'https://www.laosege.com/about',
      }} />
      <SchemaOrg type="FAQPage" faqs={faqs} />

      <main>
        {/* Hero Banner */}
        <section className="relative w-full h-[320px] md:h-[400px] overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=A%20warm%20inviting%20gentlemans%20study%20with%20rich%20dark%20wood%20furniture%20and%20leather%20armchairs%2C%20soft%20ambient%20lighting%20from%20a%20classic%20desk%20lamp%2C%20bookshelves%20filled%20with%20classic%20books%2C%20elegant%20and%20sophisticated%20atmosphere%2C%20warm%20brown%20and%20cream%20tones&width=1600&height=600&seq=about-hero&orientation=landscape"
              alt="关于老色哥"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
          </div>
          <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white mb-3">
              关于老色哥
            </h1>
            <p className="text-base md:text-lg text-white/80 max-w-xl">
              成熟男人的穿搭圣经，品味男人的生活方式
            </p>
          </div>
        </section>

        <div className="max-w-7xl mx-auto px-4 md:px-6 pt-4">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: '关于我们' },
            ]}
          />
        </div>

        {/* Brand Intro */}
        <section className="max-w-7xl mx-auto px-4 md:px-6 py-8 md:py-12">
          <div className="max-w-3xl">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-4">
              品牌介绍
            </h2>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              {brandInfo.description}
            </p>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
              <div className="bg-background-100/70 rounded-lg p-5">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100/70 text-primary-600 mb-3">
                  <i className="ri-focus-2-line text-lg"></i>
                </div>
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">我们的使命</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{brandInfo.mission}</p>
              </div>
              <div className="bg-background-100/70 rounded-lg p-5">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-100/80 text-accent-600 mb-3">
                  <i className="ri-eye-line text-lg"></i>
                </div>
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">我们的愿景</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{brandInfo.vision}</p>
              </div>
            </div>
          </div>
        </section>

        {/* Stats */}
        <section className="bg-background-100/50 border-y border-background-200/50">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-3xl md:text-4xl font-heading font-bold text-primary-600 mb-1">{stat.value}</div>
                  <div className="text-sm text-foreground-600">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Milestones */}
        <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 text-center mb-10">
            发展历程
          </h2>
          <div className="max-w-3xl mx-auto">
            <div className="relative">
              <div className="absolute left-5 top-0 bottom-0 w-px bg-background-300"></div>
              <div className="space-y-8">
                {milestones.map((m, i) => (
                  <div key={m.year} className="relative pl-14">
                    <div className={`absolute left-3.5 top-1 w-3.5 h-3.5 rounded-full border-2 ${
                      i === milestones.length - 1
                        ? 'bg-primary-500 border-primary-500'
                        : 'bg-background-50 border-background-300'
                    }`}></div>
                    <div className="bg-background-50 border border-background-200/70 rounded-lg p-5">
                      <span className="inline-block px-2.5 py-0.5 text-xs font-semibold bg-primary-100/80 text-primary-700 rounded-full mb-2">
                        {m.year}
                      </span>
                      <h3 className="text-base font-heading font-semibold text-foreground-900 mb-1.5">{m.title}</h3>
                      <p className="text-sm text-foreground-600 leading-relaxed">{m.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Team */}
        <section className="bg-background-100/50 border-y border-background-200/50">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 text-center mb-10">
              核心团队
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
              {team.map((member) => (
                <div key={member.name} className="bg-background-50 rounded-lg border border-background-200/70 p-6 text-center">
                  <div className="w-20 h-20 mx-auto rounded-full overflow-hidden mb-4">
                    <img src={member.avatar} alt={member.name} className="w-full h-full object-cover" />
                  </div>
                  <h3 className="text-base font-heading font-semibold text-foreground-900 mb-1">{member.name}</h3>
                  <p className="text-xs text-primary-600 font-medium mb-3">{member.role}</p>
                  <p className="text-sm text-foreground-600 leading-relaxed">{member.intro}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 text-center mb-10">
            用户口碑
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto">
            {testimonials.map((t) => (
              <div key={t.name} className="bg-background-50 rounded-lg border border-background-200/70 p-6">
                <div className="flex items-center gap-1 mb-3 text-accent-500">
                  {[1, 2, 3, 4, 5].map((i) => (
                    <i key={i} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                  &ldquo;{t.content}&rdquo;
                </p>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                    <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <div className="text-sm font-medium text-foreground-900">{t.name}</div>
                    <div className="text-xs text-foreground-500">{t.age} &middot; {t.city}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* FAQ */}
        <section className="bg-background-100/50 border-y border-background-200/50">
          <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 text-center mb-10">
              常见问题
            </h2>
            <div className="max-w-3xl mx-auto space-y-4">
              {faqs.map((faq) => (
                <details key={faq.question} className="group bg-background-50 rounded-lg border border-background-200/70">
                  <summary className="flex items-center justify-between cursor-pointer p-5 text-sm md:text-base font-medium text-foreground-900 list-none">
                    {faq.question}
                    <i className="ri-arrow-down-s-line text-lg text-foreground-500 group-open:rotate-180 transition-transform duration-200"></i>
                  </summary>
                  <div className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* Contact */}
        <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 text-center mb-10">
            联系我们
          </h2>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 max-w-5xl mx-auto">
            <div>
              <div className="space-y-5">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100/70 text-primary-600 flex-shrink-0">
                    <i className="ri-map-pin-line text-lg"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-900 mb-1">公司地址</h4>
                    <p className="text-sm text-foreground-600">{brandInfo.address}</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100/70 text-primary-600 flex-shrink-0">
                    <i className="ri-phone-line text-lg"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-900 mb-1">联系电话</h4>
                    <p className="text-sm text-foreground-600">{brandInfo.phone}</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100/70 text-primary-600 flex-shrink-0">
                    <i className="ri-mail-line text-lg"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h4>
                    <p className="text-sm text-foreground-600">{brandInfo.email}</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100/70 text-primary-600 flex-shrink-0">
                    <i className="ri-wechat-line text-lg"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-900 mb-1">微信公众号</h4>
                    <p className="text-sm text-foreground-600">{brandInfo.wechat}</p>
                  </div>
                </div>
              </div>
            </div>

            <div>
              {contactStatus === 'success' ? (
                <div className="bg-background-100/70 rounded-lg p-8 text-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-100/70 mx-auto mb-4">
                    <i className="ri-check-line text-2xl text-primary-600"></i>
                  </div>
                  <p className="text-lg font-heading font-semibold text-foreground-900">消息已发送！</p>
                  <p className="text-sm text-foreground-600 mt-2">感谢您的留言，我们会在2个工作日内回复。</p>
                </div>
              ) : (
                <form ref={contactFormRef} onSubmit={handleContactSubmit} data-readdy-form="" className="bg-background-100/70 rounded-lg p-6">
                  <div className="space-y-4">
                    <div>
                      <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-700 mb-1.5">姓名</label>
                      <input
                        id="contact-name"
                        type="text"
                        name="name"
                        required
                        className="w-full px-4 py-2.5 text-sm bg-background-50 text-foreground-900 rounded-md border border-background-200 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-transparent"
                        placeholder="请输入您的姓名"
                      />
                    </div>
                    <div>
                      <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-700 mb-1.5">邮箱</label>
                      <input
                        id="contact-email"
                        type="email"
                        name="email"
                        required
                        className="w-full px-4 py-2.5 text-sm bg-background-50 text-foreground-900 rounded-md border border-background-200 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-transparent"
                        placeholder="请输入您的邮箱"
                      />
                    </div>
                    <div>
                      <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-700 mb-1.5">留言内容</label>
                      <textarea
                        id="contact-message"
                        name="message"
                        required
                        maxLength={500}
                        rows={4}
                        className="w-full px-4 py-2.5 text-sm bg-background-50 text-foreground-900 rounded-md border border-background-200 focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-transparent resize-none"
                        placeholder="请输入您的留言（500字以内）"
                      ></textarea>
                    </div>
                    <input
                      type="text"
                      name="phone_alt"
                      tabIndex={-1}
                      autoComplete="off"
                      aria-hidden="true"
                      readOnly
                      className="honeypot-field"
                    />
                    {contactStatus === 'error' && (
                      <p className="text-xs text-red-500">{contactError}</p>
                    )}
                    <button
                      type="submit"
                      className="w-full py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium text-sm rounded-md transition-colors duration-200 whitespace-nowrap"
                    >
                      发送消息
                    </button>
                  </div>
                </form>
              )}
            </div>
          </div>
        </section>
      </main>
    </>
  );
}